import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const combineSystem: TickSystem<GameState, GameAction> = {
  name: 'combine',

  update(state, deltaTime, dispatch) {
    if (!state.pendingCombine) return state;
    if (state.pendingCombine.status === 'waiting-server') return state;

    const remaining = state.pendingCombine.remaining - deltaTime;
    if (remaining > 0) {
      return {
        ...state,
        pendingCombine: {
          ...state.pendingCombine,
          remaining
        }
      };
    }

    if (state.authToken) {
      return {
        ...state,
        pendingCombine: {
          ...state.pendingCombine,
          remaining: 0,
          status: 'waiting-server'
        }
      };
    }

    dispatch({
      type: 'RESOLVE_PENDING_COMBINE',
      payload: { a: state.pendingCombine.a, b: state.pendingCombine.b }
    });

    return {
      ...state,
      pendingCombine: null
    };
  }
};
